import {
    clientFeedbackExemptionStatus,
    clientFeedbackStatuses,
    userStatus,
    mprStatus,
    planStatus,
    ragStatus,
    riskRegisterRatings,
    taskPlanTypes,
    yesNoOptions,
    budgetUpdateStatuses,
    taskStatus,
    changeRegisterStatus,
    workOrderExpenseStatuses,
    invoiceRequestStatuses,
    projectDeliverableStatus,
    riskAndOpportunityStatuses,
} from 'src/consts.js'

export const planStatusColors = {
    [planStatus.STATUS_ACTIVE]: 'positive',
    [planStatus.STATUS_CLOSED]: 'dark',
    [planStatus.STATUS_ON_HOLD]: 'warning',
    [planStatus.STATUS_UNKNOWN]: 'info',
}

export const mprStatusColors = {
    [mprStatus.STATUS_READY_TO_START]: 'light-blue-10',
    [mprStatus.STATUS_DRAFT]: 'warning',
    [mprStatus.STATUS_PM_SUBMITTED]: 'positive',
    [mprStatus.STATUS_PD_SUBMITTED]: 'positive',
    [mprStatus.STATUS_BL_SUBMITTED]: 'positive',
    [mprStatus.STATUS_CL_SUBMITTED]: 'positive',
    [mprStatus.STATUS_COMPLETE]: 'positive',
    [mprStatus.STATUS_HOLD]: 'grey-6',
}

export const userStatusColors = {
    [userStatus.STATUS_ACTIVE]: 'positive',
    [userStatus.STATUS_INACTIVE]: 'grey-6',
    [userStatus.STATUS_TERMINATED]: 'negative',
    [userStatus.STATUS_UNKNOWN]: 'warning',
}

export const invoiceRequestStatusColors = {
    [invoiceRequestStatuses.STATUS_DRAFT]: 'warning',
    [invoiceRequestStatuses.STATUS_SUBMITTED]: 'grey-6',
    [invoiceRequestStatuses.STATUS_PROCESSING]: 'grey-8',
    [invoiceRequestStatuses.STATUS_COMPLETE]: 'positive',
    [invoiceRequestStatuses.STATUS_CANCELLED]: 'info',
}

export const ragStatusColors = {
    [ragStatus.RED]: 'negative',
    [ragStatus.AMBER]: 'warning',
    [ragStatus.GREEN]: 'positive',
}

export const projectDeliverableStatusColors = {
    [projectDeliverableStatus.STATUS_NOT_STARTED]: 'grey-6',
    [projectDeliverableStatus.STATUS_IN_PROGRESS]: 'warning',
    [projectDeliverableStatus.STATUS_COMPLETED]: 'positive',
}

export const clientFeedbackExemptionStatusColors = {
    [clientFeedbackExemptionStatus.SUBMITTED]: 'info',
    [clientFeedbackExemptionStatus.APPROVED]: 'positive',
    [clientFeedbackExemptionStatus.DECLINED]: 'warning',
}

export const yesNoNaColors = {
    [yesNoOptions.YES]: 'positive',
    [yesNoOptions.NO]: 'negative',
    [yesNoOptions.NOT_APPLICABLE]: 'grey-8',
}

export const taskPlanTypeColors = {
    [taskPlanTypes.TYPE_HEALTH_AND_SAFETY]: 'negative',
    [taskPlanTypes.TYPE_RISK]: 'info',
    [taskPlanTypes.TYPE_SAFETY_IN_DESIGN]: 'grey-6',
    [taskPlanTypes.TYPE_ENVIRONMENTAL]: 'warning',
    [taskPlanTypes.TYPE_SUSTAINABILITY]: 'positive',
    [taskPlanTypes.TYPE_OTHER]: 'secondary',
    [taskPlanTypes.TYPE_HSE_RISK_REGISTER]: 'light-blue-10',
}

export const riskRegisterRatingColors = {
    [riskRegisterRatings.RATING_LOW]: 'positive',
    [riskRegisterRatings.RATING_MEDIUM]: 'info',
    [riskRegisterRatings.RATING_HIGH]: 'warning',
    [riskRegisterRatings.RATING_CRITICAL]: 'danger',
}

export const budgetUpdateStatusColors = {
    [budgetUpdateStatuses.STATUS_IN_PROGRESS]: 'info',
    [budgetUpdateStatuses.STATUS_APPROVED]: 'positive',
    [budgetUpdateStatuses.STATUS_DECLINED]: 'negative',
    [budgetUpdateStatuses.STATUS_UNDER_REVIEW]: 'warning',
    [budgetUpdateStatuses.STATUS_PA_REVIEW]: 'blue',
}

export const riskAndOpportunityStatusColors = {
    [riskAndOpportunityStatuses.STATUS_OPEN]: 'positive',
    [riskAndOpportunityStatuses.STATUS_CLOSED]: 'negative',
}

export const clientFeedbackStatusColors = {
    [clientFeedbackStatuses.STATUS_PENDING]: 'warning',
    [clientFeedbackStatuses.STATUS_RECEIVED]: 'positive',
}

export const taskStatusColors = {
    [taskStatus.STATUS_SCHEDULED]: 'grey-8',
    [taskStatus.STATUS_TENATIVE]: 'warning',
    [taskStatus.STATUS_IN_PROGRESS]: 'warning',
    [taskStatus.STATUS_COMPLETE]: 'positive',
    [taskStatus.STATUS_CANCELLED]: 'primary',
}

export const changeRegisterStatusColors = {
    [changeRegisterStatus.STATUS_DRAFT]: 'info',
    [changeRegisterStatus.STATUS_APPROVED]: 'positive',
    [changeRegisterStatus.STATUS_REJECTED]: 'danger',
    [changeRegisterStatus.STATUS_IN_PROGRESS]: 'accent',
    [changeRegisterStatus.STATUS_CANCELED]: 'warning',
    [changeRegisterStatus.STATUS_COMPLETED]: 'positive',
}

export const workOrderExpenseStatusColors = {
    [workOrderExpenseStatuses.STATUS_CURRENT_INVOICE_PROPOSAL]: 'warning',
    [workOrderExpenseStatuses.STATUS_PARKED]: 'info',
    [workOrderExpenseStatuses.STATUS_READY_FOR_INVOICING]: 'positive',
    [workOrderExpenseStatuses.STATUS_CLOSED]: 'negative',
}
